import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import { TooltipButton } from 'vdlib';
import LookupsHelper from 'lib/LookupsHelper';

import Popconfirm from 'antd/lib/popconfirm';

import _ from 'lodash';

export const createEstimationColumns = (
  insurances,
  statuses,
  runEstimation,
  deleteEstimation,
  isFailed,
  hasActions,
  isParts
) =>
  [
    {
      title: 'ID',
      key: _.uniqueId(),
      dataIndex: 'EstimationID',
      width: 150,
      align: 'center',
    },
    {
      title: <div style={{ textAlign: 'center' }}>Ασφαλιστική</div>,
      key: _.uniqueId(),
      dataIndex: 'InsuranceID',
      width: 400,
      align: 'center',
      render: (text, record, index) => (
        <div style={{ textAlign: 'center' }}>
          <div>
            <span style={{ fontWeight: 600, textAlign: 'center' }}>
              {LookupsHelper.getDescription(insurances, record.InsuranceID)}
            </span>
          </div>
          <div>
            <span style={{ fontSize: 12, textAlign: 'center' }}>
              {record.UserName || record.ExpertUsername}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: 'Χαρακτηριστικά',
      key: _.uniqueId(),
      dataIndex: 'characteristics',
      width: 350,
      align: 'center',
      render: (text, record, index) => (
        <div>
          <div>
            <span style={{ fontWeight: 600 }}>
              {record.Make} {record.Model}
            </span>
          </div>
          <div>
            <span style={{ fontSize: 12 }}>{record.RegistrationNumber}</span>
          </div>
        </div>
      ),
    },
  ]
    .concat(
      isFailed
        ? {
            title: I.t('FAILED_REASON'),
            key: _.uniqueId(),
            dataIndex: 'LastFailureReason',
            width: 400,
            align: 'center',
          }
        : []
    )
    .concat(
      !isParts
        ? [
            {
              title: I.t('STATUS'),
              key: _.uniqueId(),
              dataIndex: 'StatusID',
              align: 'center',
              render: (text, record, index) => (
                <div
                  className={
                    LookupsHelper.getDescription(statuses, record.StatusID)
                      .toLowerCase()
                      .includes('fail')
                      ? 'label label-danger'
                      : LookupsHelper.getDescription(statuses, record.StatusID)
                          .toLowerCase()
                          .includes('pending')
                      ? 'label label-warning'
                      : LookupsHelper.getDescription(statuses, record.StatusID)
                          .toLowerCase()
                          .includes('processing')
                      ? 'label label-default'
                      : LookupsHelper.getDescription(statuses, record.StatusID)
                          .toLowerCase()
                          .includes('small')
                      ? 'label label-success'
                      : 'label label-primary'
                  }
                >
                  {LookupsHelper.getDescription(statuses, record.StatusID)}
                </div>
              ),
            },
            {
              title: I.t('DATE_LAST_RUN'),
              key: _.uniqueId(),
              dataIndex: 'DateLastProcessing',
              width: 150,
              align: 'center',
              render: (text, record, index) => (
                <span>{record.DateLastProcessing}</span>
              ),
            },
            {
              title: I.t('DATE_CREATION'),
              key: _.uniqueId(),
              dataIndex: 'DateCreation',
              width: 150,
              align: 'center',
              render: (text, record, index) => (
                <span>{record.DateCreation}</span>
              ),
            },
            {
              title: I.t('DATE_MODIFICATION'),
              key: _.uniqueId(),
              dataIndex: 'DateModification',
              width: 150,
              align: 'center',
              render: (text, record, index) => (
                <span>{record.DateModification}</span>
              ),
            },
            {
              title: 'Retries',
              key: _.uniqueId(),
              dataIndex: 'RetryNumber',
              align: 'center',
              render: (text, record, index) => (
                <div
                  style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}
                >
                  {record.RetryNumber}
                </div>
              ),
            },
          ]
        : []
    )
    .concat(
      hasActions
        ? {
            title: 'Ενέργειες',
            key: _.uniqueId(),
            dataIndex: 'energies',
            width: 100,
            fixed: 'right',
            render: (text, record, index) =>
              record.StatusID === 1 ||
              record.StatusID === 6 ? null : record.StatusID === 7 ? (
                <div
                  className="cell-fix-wrap"
                  style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}
                >
                  <Popconfirm
                    placement="bottom"
                    title={I.t('RUN_SELECTED_CONFIRMATION')}
                    onConfirm={() => runEstimation(record, true)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <TooltipButton
                      className="green action-button"
                      icon="rocket"
                      text={I.t('RUN_FORCE')}
                      style={{ marginRight: 5 }}
                    />
                  </Popconfirm>
                  <Popconfirm
                    placement="bottom"
                    title={I.t('DELETE_SELECTED_CONFIRMATION')}
                    onConfirm={() => deleteEstimation(record.EstimationID)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <TooltipButton
                      className="red action-button"
                      icon="close"
                      text={I.t('DELETE')}
                      style={{ marginRight: 5 }}
                    />
                  </Popconfirm>
                </div>
              ) : (
                <div className="cell-fix-wrap">
                  <Popconfirm
                    placement="bottom"
                    title={I.t('RUN_SELECTED_CONFIRMATION')}
                    onConfirm={() => runEstimation(record)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <TooltipButton
                      className="blue action-button"
                      icon="flag-checkered"
                      text={I.t('RUN')}
                      style={{ marginRight: 5 }}
                    />
                  </Popconfirm>
                  <Popconfirm
                    placement="bottom"
                    title={I.t('DELETE_SELECTED_CONFIRMATION')}
                    onConfirm={() => deleteEstimation(record.EstimationID)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <TooltipButton
                      className="red action-button"
                      icon="close"
                      text={I.t('DELETE')}
                      style={{ marginRight: 5 }}
                    />
                  </Popconfirm>
                </div>
              ),
          }
        : []
    );
